import styled from 'styled-components'

export const GraphComponents = styled.div`
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #303746;
  margin-bottom: 50px;
  h1 {
    font-size: 30px;
    font-weight: bold;
    margin: 50px;
  }
`

export const GraphDetails = styled.div`
  background-color: #fff;
  height: 66vh;
  width: 100%;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`
